import { gsap } from 'gsap'

document.addEventListener('DOMContentLoaded', () => {

  var ww = window.innerWidth;
  var hh = window.innerHeight;
  var footer_top = $(".globalFooter").offset().top;

  const $snow = $('.snow');
  const $btn = $(".btn");

  $(window).on('load', function() {

    $('body').addClass('load');

    if (Useragnt.ios){
      $("meta[name='viewport']").attr('content','width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    }
    op_anim();

  });

  $(document).on("click", ".globalHeader .btn", function(){
    ww = window.innerWidth;
    if(ww < 771){
      var send_val = 'top-btn-sp';
    } else {
      var send_val = 'top-btn-pc';
    }
    gtag('event', 'click', {'event_category': 'kafun','event_label': send_val,'value': '1'});
  });

  $(document).on("click", ".info .button", function(){
    ww = window.innerWidth;
    if(ww < 771){
      var send_val = 'bottom-btn-sp';
    } else {
      var send_val = 'bottom-btn-pc';
    }
    gtag('event', 'click', {'event_category': 'kafun','event_label': send_val,'value': '1'});
  });

  function scrollShow() {
    $('.scroll-show').each(function(i, elm) {

      const $wh = $(window).height();
      const $st = $(window).scrollTop();
      const $sb = $st + $wh * .75;

      if ($(elm).is('.is-show')) {
        return true;
      }

      const $pos = $(elm).offset().top;
      if ($pos < $sb) {
        $(elm).addClass('is-show');
      }
      return;
    });
  }

  function snow(){

    if($('.mobile').length){
      var snow_num = 25;
    } else {
      var snow_num = 50;
    }

    var body_height = $('body').height();
    $snow.height(body_height);

    $snow.snowfall(
			{
		    // 雪の量 (数値)
		    flakeCount : snow_num,
		    // 色 (RGB)
		    flakeColor : "#7edced",
		    // z-indexの値
		    flakeIndex : "888",
		    // 最小サイズ （数値）
		    minSize : 8,
		    // 最大サイズ（数値）
		    maxSize : 15,
		    // 最低速度（数値）
		    minSpeed : 1,
		    // 最高速度（数値）
		    maxSpeed : 2,
		    // 雪の形を丸にする（boolean）
		    round : true,
		    // 影をつける（boolean）
		    shadow : false,
			}
		);
    $snow.snowfall(
			{
		    // 雪の量 (数値)
		    flakeCount : snow_num,
		    // 色 (RGB)
		    flakeColor : "#f8f2b6",
		    // z-indexの値
		    flakeIndex : "888",
		    // 最小サイズ （数値）
		    minSize : 8,
		    // 最大サイズ（数値）
		    maxSize : 15,
		    // 最低速度（数値）
		    minSpeed : 1,
		    // 最高速度（数値）
		    maxSpeed : 2,
		    // 雪の形を丸にする（boolean）
		    round : true,
		    // 影をつける（boolean）
		    shadow : false,
			}
		);
  }

  function op_anim(){
    $(".loading").height(hh);

    TweenMax.to("body", 0.5,{
      opacity: 1
    });
    TweenMax.to(".loading", 0.5,{
      delay: 4,
      opacity: 0
    });
    TweenMax.to(".title_anim", 0,{
      delay: 5,
      opacity: 1,
      onComplete : function(){
        $(".title_anim").addClass("move");
      }
    });
    TweenMax.to(".mv_text .title_img", 1,{
      delay: 6,
      opacity: 1
    });
    TweenMax.to(".mv_img .goods", 1,{
      delay: 6,
      opacity: 1,
      y: 0
    });
    TweenMax.to(".mv_img .fkds", 1,{
      delay: 7,
      opacity: 1,
      y: 0
    });
    TweenMax.to(".mv_text .text", 1,{
      delay: 7,
      opacity: 1,
      y: 0
    });
    TweenMax.to(".scroll", 1,{
      delay: 7,
      opacity: 1
    });
    TweenMax.to(".attention", 1,{
      delay: 7,
      opacity: 1
    });
    TweenMax.to(".btn", 1,{
      delay: 7,
      opacity: 1,
      onComplete : function(){
        $(".btn").addClass("move");
        $("body").css("position","relative");
        snow();
      }
    });
  }

  $(window).scroll(function() {

    var scr = $(window).scrollTop();

    if(scr + hh > footer_top){
      $btn.css("opacity", 0);
    } else {
      $btn.css("opacity", 1);
    }

    if ($('body').hasClass('load')) {
      scrollShow();
    }

  });

  $(window).resize(function() {

    ww = window.innerWidth;
    hh = window.innerHeight;
    footer_top = $(".globalFooter").offset().top;

    var body_height = $('body').height();
    $snow.height(body_height);

  });


});
